import { ca } from '@cian/analytics';
import { IPage } from '../../../types/redux';

interface ITrackBannerClickParams {
  label: string;
  page: IPage;
}

export const trackBannerClick = ({ label, page }: ITrackBannerClickParams) => {
  ca('eventSite', {
    action: 'Click_sopr',
    category: 'Promo',
    name: 'oldevent',
    label,
    page: {
      ...page,
      extra: {
        block: label,
      },
    },
  });
};
